<template>
  <DefaultLayout
    menuIndex="/equipmentList"
    openeds="equipment"
  >

    <div class="page-header">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        ref="formRef"
      >
        <el-form-item label="所属公司">
          <el-select
            v-model="form.company"
            placeholder="选择所属公司"
            clearable
          >
            <el-option
              v-for="item in options.company"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="机械类型">
          <el-select
            v-model="form.mechanicalType"
            placeholder="选择机械类型"
            clearable
          >
            <el-option
              v-for="item in options.mechanicalType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="工艺类型">
          <el-select
            v-model="form.processType"
            placeholder="选择工艺类型"
            clearable
          >
            <el-option
              v-for="item in options.processType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="固定资产">
          <el-input
            v-model="form.assetCode"
            placeholder="固定资产编号，支持模糊查询"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit(formRef)"
            :icon="Search"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="padding: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column
          type="index"
          label="#"
          width="55"
          :resizable="false"
        />
        <el-table-column
          prop="assetCode"
          label="固定资产编号"
          width="130"
          :resizable="false"
        />
        <el-table-column type="expand">
          <template #default="props">
            <div
              m="3"
              class="table-details"
            >
              <p m="t-0 b-2"><span>设备描述: </span>{{ props.row.description }}</p>
              <p m="t-0 b-2"><span>电子说明书: </span>{{ props.row.qrCode }}</p>
              <p m="t-0 b-2"><span>备注: </span>{{ props.row.remark }}</p>
              <p
                m="t-0 b-2"
                style="display: flex;"
              ><span>设备照片: </span>
              <ul>
                <li
                  v-for="item in props.row.picList"
                  :key="item"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.url"
                    :fit="'contain'"
                    :preview-teleported="true"
                    :preview-src-list="props.row.picList.map(item => { return item.url })"
                  />
                </li>
              </ul>
              </p>

              <p m="t-0 b-2"><span>工艺工装版本: </span>{{ props.row.processTooling }}</p>
              <p m="t-0 b-2"><span>夹持工装版本: </span>{{ props.row.clampTooling }}</p>
              <p m="t-0 b-2"><span>供胶系统版本: </span>{{ props.row.glueSupplySystem }}</p>
              <p m="t-0 b-2"><span>清洗工装版本: </span>{{ props.row.cleaningMechanism }}</p>
              <p m="t-0 b-2"><span>机身版本: </span>{{ props.row.machineBody }}</p>
              <p m="t-0 b-2"><span>运动机构版本: </span>{{ props.row.motionMechanism }}</p>

              <p m="t-0 b-2"><span>机构装配人员: </span>{{ props.row.mechanismAssembleUser }}</p>
              <p m="t-0 b-2"><span>电气接线人员: </span>{{ props.row.electricWireUser }}</p>
              <p m="t-0 b-2"><span>调试人员: </span>{{ props.row.debugUser }}</p>
              <p m="t-0 b-2"><span>检验人员: </span>{{ props.row.checkUser }}</p>

              <p m="t-0 b-2"><span>设备MAC: </span>{{ props.row.mac }}</p>
              <p
                m="t-0 b-2"
                style="display: flex;"
              ><span>设备IP: </span>
              <ul>
                <li
                  v-for="item in props.row.ipList"
                  :key="item"
                ><span style="width: 100px;">{{ item.name }}:</span> {{ item.ip }}</li>
              </ul>
              </p>

              <p m="t-0 b-2"><span>外形尺寸(mm): </span>{{ props.row.shapeSize }}</p>
              <p m="t-0 b-2"><span>额定电压(V): </span>{{ props.row.ratedVoltage }}</p>
              <p m="t-0 b-2"><span>额定功率(W): </span>{{ props.row.ratedPower }}</p>
              <p m="t-0 b-2"><span>额定气压(Mpa): </span>{{ props.row.ratedAirPressure }}</p>
              <p m="t-0 b-2"><span>设备重量(Kg): </span>{{ props.row.weight }}</p>

              <p m="t-0 b-2"><span>是否为产线: </span>{{ props.row.isProductionLine ? '是' : '否' }}</p>
              <p m="t-0 b-2"><span>所属产线: </span>{{ props.row.productionLineName }}</p>
              <p m="t-0 b-2"><span>上一次保养日期: </span>{{ props.row.lastMaintenanceDate }}</p>
              <p m="t-0 b-2"><span>启用状态: </span>{{ props.row.isEnable ? '开' : '关' }}</p>
              <p m="t-0 b-2"><span>所属工厂: </span>{{ props.row.factory }}</p>
              <p m="t-0 b-2"><span>所属车间: </span>{{ props.row.workshop }}</p>
              <p m="t-0 b-2"><span>装配完成度: </span>{{ props.row.assemblyCompletion }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="project"
          label="项目模块"
          :resizable="false"
        />
        <el-table-column
          prop="name"
          label="设备名称"
          width="120"
          :resizable="false"
        />
        <el-table-column
          prop="specificationModel"
          label="规格型号"
          width="120"
          :resizable="false"
        />
        <el-table-column
          prop="versionName"
          label="设备版本"
          width="85"
          :resizable="false"
        />
        <el-table-column
          prop="mechanicalTypeName"
          label="机械类型"
          width="120"
          :resizable="false"
        />
        <el-table-column
          prop="processTypeName"
          label="工艺类型"
          width="85"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="nature"
          label="商业类型"
          width="85"
          :resizable="false"
        />
        <el-table-column
          prop="factoryDate"
          label="出厂日期"
          width="100"
          :resizable="false"
        />
        <el-table-column
          prop="creationTime"
          label="上线时间"
          width="100"
          :resizable="false"
        />
        <el-table-column
          prop="offlineTime"
          label="过期时间"
          width="100"
          :resizable="false"
        />
        <el-table-column
          prop="company"
          label="所属公司"
          width="120"
          :resizable="false"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="120"
          :resizable="false"
        >
          <template #default="scope">
            <el-button @click="openEdit(scope)">
              <el-icon>
                <Edit />
              </el-icon>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      v-model="dialogFormVisible"
      title="编辑设备"
    >
      <el-form
        :model="editForm"
        ref="editFormRef"
        :rules="editRules"
      >
        <el-form-item
          label="固定资产编号"
          :label-width="formLabelWidth"
          prop="assetCode"
        >
          <el-input
            v-model="editForm.assetCode"
            autocomplete="off"
            disabled
          />
        </el-form-item>
        <el-form-item
          label="设备名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            v-model="editForm.name"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="设备MAC"
          :label-width="formLabelWidth"
          prop="mac"
        >
          <el-input
            v-model="editForm.mac"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="商业类型"
          :label-width="formLabelWidth"
          prop="nature"
        >
          <el-radio-group v-model="editForm.nature">
            <el-radio
              label="买断"
              border
            >买断</el-radio>
            <el-radio
              label="租赁"
              border
            >租赁</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="设备IP"
          :label-width="formLabelWidth"
          prop="ip"
        >
          <el-input
            v-model="editForm.ip"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="到期时间"
          :label-width="formLabelWidth"
          prop="offlineTime"
        >
          <el-date-picker
            v-model="editForm.offlineTime"
            type="date"
            placeholder="请选择日期"
            :disabled="editForm.nature === '买断'"
          />
        </el-form-item>
        <el-form-item
          label="是否为产线"
          :label-width="formLabelWidth"
          prop="isProductionLine"
        >
          <el-switch
            v-model="editForm.isProductionLine"
            inline-prompt
            active-text="是"
            inactive-text="否"
            size="large"
          />
        </el-form-item>
        <el-form-item
          label="启用状态"
          :label-width="formLabelWidth"
          prop="isEnable"
        >
          <el-switch
            v-model="editForm.isEnable"
            inline-prompt
            active-text="开"
            inactive-text="关"
            size="large"
          />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
          :label-width="formLabelWidth"
          style="width: 100%;"
        >
          <el-input
            v-model="editForm.remark"
            :rows="2"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="primary"
            @click="submitForm(editFormRef)"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from '../components/layout/DefaultLayout.vue'
import router from '../router'
import { EquipmentInfo, Companies, ProductionLines, EquipmentSort, QrCode, ProjectRecord } from '../api/request.js'
import { reactive, onMounted, ref, markRaw } from 'vue'
import { Search, QuestionFilled } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import moment from 'moment'

const formRef = ref()
const editFormRef = ref()

const form = reactive({
  processType: '',
  mechanicalType: '',
  company: '',
  productionLine: '',
  assetCode: ''
})

const editForm = reactive({
  assetCode: '',
  name: '',
  mac: '',
  nature: '',
  ip: '',
  offlineTime: '',
  isProductionLine: false,
  isEnable: true,
  id: '',
  remark: '',
})

const editRules = reactive({
  name: [
    { required: true, message: '请输入设备名称', trigger: 'blur' },
  ],
  mac: [
    { required: true, message: '请输入设备MAC', trigger: 'blur' },
  ],
  ip: [
    { required: true, message: '请输入设备IP', trigger: 'blur' },
  ],
})

const options = reactive({
  deviceName: [
    // {
    //   id: '1',
    //   name: '智能涂胶专机'
    // },
    // {
    //   id: '2',
    //   name: '智能喷胶专机'
    // },
    // {
    //   id: '3',
    //   name: '智能打磨专机'
    // }
  ],
  processType: [
    // {
    //     id: '1',
    //     code: 'PJ',
    //     name: '喷胶'
    // }
  ],
  mechanicalType: [],
  company: [
    // {
    //     id: '1',
    //     name: '浙江大东鞋业'
    // }
  ],
  productionLines: [
    // {
    //     code: 'p1',
    //     id: '1',
    //     name: '1号线'
    // }
  ],
  qrCode: [
    // {
    //   id: '1',
    //   title: '说明书1'
    // },
    // {
    //   id: '2',
    //   title: '说明书2'
    // }
  ],
  project: [
    // {
    //   id: '1',
    //   name: '项目1'
    // },
    // {
    //   id: '2',
    //   name: '项目2'
    // }
  ]
})

const tableData = ref([
  {
    name: '',
    mac: '',
    mechanicalTypeName: '',
    processTypeName: '',
    nature: '',
    ip: '',
    creationTime: '',
    offlineTime: '',
    productionLineName: '',
    assetCode: '',
    company: '',
    factory: '',
    workshop: '',
    isProductionLine: '',
    isEnable: '',
    id: '',
    remark: '',
    project: '',
    description: '',
    qrCode: '',
    ipList: [
      { ip: '', name: '内网IP' },
      { ip: '', name: '外网IP' },
      { ip: '', name: '控制器IP' },
      { ip: '', name: 'PlcIP' },
      { ip: '', name: '机器人IP' },
      { ip: '', name: '3D机器视觉IP' },
      { ip: '', name: '2D机器视觉IP' },
      { ip: '', name: '皮带伺服电机IP' }
    ],
    picList: [],

    specificationModel: '',
    versionName: '',
    shapeSize: '',
    ratedVoltage: '',
    ratedPower: '',
    ratedAirPressure: '',
    weight: '',
    factoryDate: '',
    lastMaintenanceDate: '',

    processTooling: '',
    clampTooling: '',
    glueSupplySystem: '',
    cleaningMechanism: '',
    machineBody: '',
    motionMechanism: '',

    mechanismAssembleUser: '',
    electricWireUser: '',
    debugUser: '',
    checkUser: '',
  },
])

const dialogFormVisible = ref(false);
const formLabelWidth = '140px';

onMounted(async () => {
  //请求工艺类型
  EquipmentInfo.GetEquipmentProcessTypes().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        code: res[i].code,
        name: res[i].name
      });
    }
    options.processType = optionsTem;
  })
  //请求机械类型
  EquipmentInfo.GetEquipmentMechanicalTypes().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        code: res[i].code,
        name: res[i].name
      });
    }
    options.mechanicalType = optionsTem;
  })
  //请求公司
  Companies.GetCompanyAccountInformation().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        name: res[i].name
      });
    }
    options.company = optionsTem;
  })
  //请求产线
  ProductionLines.Get().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        name: res[i].name,
        code: res[i].code
      });
    }
    options.productionLines = optionsTem;
  })
  //请求设备类别
  await EquipmentSort.List().then((res) => {
    // console.log(res);
    options.deviceName = res;
  })
  //请求电子说明书列表
  await QrCode.GetDropDownList().then((res) => {
    // console.log(res);
    options.qrCode = res?.content;
  })
  //请求项目模块
  await ProjectRecord.List().then((res) => {
    // console.log(res);
    options.project = res;
  })
  //请求设备初始化
  EquipmentInfo.GetEquipments().then((res) => {
    // console.log(res);
    let tableDataTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      tableDataTem.push({
        name: options.deviceName.find((ele) => ele.id === res[i].sortId)?.name,
        mac: res[i].mac,
        mechanicalTypeName: res[i].mechanicalTypeName,
        processTypeName: res[i].processTypeName,
        nature: res[i].nature,
        ip: res[i].ip,
        creationTime: moment(res[i].creationTime).format('YYYY-MM-DD'),
        offlineTime: res[i].expireDate === null ? '' : moment(res[i].expireDate).format('YYYY-MM-DD'),
        productionLineName: res[i].productionLineName,
        assetCode: res[i].assetCode,
        isProductionLine: res[i].isProductionLine,
        isEnable: res[i].isEnable,
        id: res[i].id,
        remark: res[i].remark,
        description: res[i].description,
        qrCode: options.qrCode.find((ele) => ele.id == res[i].qrCodeId)?.title,
        ipList: [
          { ip: res[i].internalIP, name: '内网IP' },
          { ip: res[i].externalIP, name: '外网IP' },
          { ip: res[i].controllerIP, name: '控制器IP' },
          { ip: res[i].plcIP, name: 'PlcIP' },
          { ip: res[i].robotIP, name: '机器人IP' },
          { ip: res[i].camera3DIP, name: '3D机器视觉IP' },
          { ip: res[i].camera2DIP, name: '2D机器视觉IP' },
          { ip: res[i].motorIP, name: '皮带伺服电机IP' }
        ],
        project: options.project.find((ele) => ele.id == res[i].projectRecordId)?.name,
        picList: res[i].imgs,
        company: res[i].companyName,
        factory: res[i].factoryName,
        workshop: res[i].workshopName,

        specificationModel: res[i].specificationModel,
        versionName: res[i].versionName,
        shapeSize: res[i].shapeSize,
        ratedVoltage: res[i].ratedVoltage,
        ratedPower: res[i].ratedPower,
        ratedAirPressure: res[i].ratedAirPressure,
        weight: res[i].weight,
        factoryDate: res[i].factoryDate === null ? '' : moment(res[i].factoryDate).format('YYYY-MM-DD'),
        lastMaintenanceDate: res[i].lastMaintenanceDate === null ? '' : moment(res[i].lastMaintenanceDate).format('YYYY-MM-DD'),

        processTooling: res[i].processToolingVersion,
        clampTooling: res[i].clampToolingVersion,
        glueSupplySystem: res[i].glueSupplySystemVersion,
        cleaningMechanism: res[i].cleaningMechanismVersion,
        machineBody: res[i].machineBodyVersion,
        motionMechanism: res[i].motionMechanismVersion,

        mechanismAssembleUser: res[i].mechanismAssembleUser,
        electricWireUser: res[i].electricWireUser,
        debugUser: res[i].debugUser,
        checkUser: res[i].checkUser,
        assembleInfoList: res[i].assembleInfoList,
        assemblyCompletion: res[i].assembleInfoList.length > 0 ? Math.floor(res[i].assembleInfoList.filter(item => item.status === "已完成").length / res[i].assembleInfoList.length * 100) + '%' : '/'
      });
    }
    tableData.value = tableDataTem;
  })
})

const onSubmit = (formEl) => {
  // console.log(formEl)
  if (!formEl) return
  formEl.validate(() => {
    // console.log(form);
    EquipmentInfo.GetEquipments(form.company, null, form.mechanicalType, form.processType, form.assetCode).then((res) => {
      ElMessage({
        showClose: true,
        message: '查询成功',
        type: 'success',
      });
      // console.log(res);
      let tableDataTem = [];
      for (let i = 0, len = res.length; i < len; i++) {
        tableDataTem.push({
          name: options.deviceName.find((ele) => ele.id === res[i].sortId)?.name,
          mac: res[i].mac,
          mechanicalTypeName: res[i].mechanicalTypeName,
          processTypeName: res[i].processTypeName,
          nature: res[i].nature,
          ip: res[i].ip,
          creationTime: moment(res[i].creationTime).format('YYYY-MM-DD'),
          offlineTime: res[i].expireDate === null ? '' : moment(res[i].expireDate).format('YYYY-MM-DD'),
          productionLineName: res[i].productionLineName,
          assetCode: res[i].assetCode,
          isProductionLine: res[i].isProductionLine,
          isEnable: res[i].isEnable,
          id: res[i].id,
          remark: res[i].remark,
          description: res[i].description,
          qrCode: options.qrCode.find((ele) => ele.id == res[i].qrCodeId)?.title,
          ipList: [
            { ip: res[i].internalIP, name: '内网IP' },
            { ip: res[i].externalIP, name: '外网IP' },
            { ip: res[i].controllerIP, name: '控制器IP' },
            { ip: res[i].plcIP, name: 'PlcIP' },
            { ip: res[i].robotIP, name: '机器人IP' },
            { ip: res[i].camera3DIP, name: '3D机器视觉IP' },
            { ip: res[i].camera2DIP, name: '2D机器视觉IP' },
            { ip: res[i].motorIP, name: '皮带伺服电机IP' }
          ],
          project: options.project.find((ele) => ele.id == res[i].projectRecordId)?.name,
          picList: res[i].imgs,
          company: res[i].companyName,
          factory: res[i].factoryName,
          workshop: res[i].workshopName,

          specificationModel: res[i].specificationModel,
          versionName: res[i].versionName,
          shapeSize: res[i].shapeSize,
          ratedVoltage: res[i].ratedVoltage,
          ratedPower: res[i].ratedPower,
          ratedAirPressure: res[i].ratedAirPressure,
          weight: res[i].weight,
          factoryDate: res[i].factoryDate === null ? '' : moment(res[i].factoryDate).format('YYYY-MM-DD'),
          lastMaintenanceDate: res[i].lastMaintenanceDate === null ? '' : moment(res[i].lastMaintenanceDate).format('YYYY-MM-DD'),

          processTooling: res[i].processToolingVersion,
          clampTooling: res[i].clampToolingVersion,
          glueSupplySystem: res[i].glueSupplySystemVersion,
          cleaningMechanism: res[i].cleaningMechanismVersion,
          machineBody: res[i].machineBodyVersion,
          motionMechanism: res[i].motionMechanismVersion,
        });
      }
      tableData.value = tableDataTem;
    })
  })
}

const openEdit = (scope) => {
  // dialogFormVisible.value = true;
  // console.log(scope.row);
  // editForm.assetCode = scope.row.assetCode;
  // editForm.name = scope.row.name;
  // editForm.mac = scope.row.mac;
  // editForm.nature = scope.row.nature;
  // editForm.ip = scope.row.ip;
  // editForm.offlineTime = scope.row.offlineTime;
  // editForm.isProductionLine = scope.row.isProductionLine;
  // editForm.isEnable = scope.row.isEnable;
  // editForm.id = scope.row.id;
  // editForm.remark = scope.row.remark;
  ElMessageBox.confirm(
    '是否编辑固定资产编号为【' + scope.row.assetCode + '】的设备？',
    '',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'info',
      icon: markRaw(QuestionFilled),
    }
  )
    .then(() => {
      router.push('/equipmentAdd?id=' + scope.row.id)
    })
    .catch(() => {
    })
}

const submitForm = (formEl) => {
  if (!formEl) return
  // console.log(form);
  formEl.validate((valid) => {
    if (valid) {
      // console.log(form);
      ElMessageBox.confirm(
        '是否确定编辑该设备信息?',
        '编辑',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        EquipmentInfo.EditEquipment({
          id: editForm.id,
          name: editForm.name,
          mac: editForm.mac,
          nature: editForm.nature,
          ip: editForm.ip,
          expireDate: editForm.expireDate,
          isProductionLine: editForm.isProductionLine,
          isEnable: editForm.isEnable,
          remark: editForm.remark
        }).then(() => {
          ElMessage({
            showClose: true,
            message: '编辑成功',
            type: 'success',
          });
          formEl.resetFields();
          dialogFormVisible.value = false;
          EquipmentInfo.GetEquipments(form.company, null, form.mechanicalType, form.processType, form.assetCode).then((res) => {
            // console.log(res);
            let tableDataTem = [];
            for (let i = 0, len = res.length; i < len; i++) {
              tableDataTem.push({
                name: res[i].name,
                mac: res[i].mac,
                mechanicalTypeName: res[i].mechanicalTypeName,
                processTypeName: res[i].processTypeName,
                nature: res[i].nature,
                ip: res[i].ip,
                creationTime: moment(res[i].creationTime).format('YYYY-MM-DD'),
                offlineTime: res[i].expireDate === null ? '' : moment(res[i].expireDate).format('YYYY-MM-DD'),
                productionLineName: res[i].productionLineName,
                assetCode: res[i].assetCode,
                isProductionLine: res[i].isProductionLine,
                isEnable: res[i].isEnable,
                id: res[i].id,
                remark: res[i].remark
              });
            }
            tableData.value = tableDataTem;
          })
        })
      })
        .catch(() => {
          ElMessage({
            type: 'info',
            message: '已取消',
          })
        })
    } else {
      // console.log('error submit!')
      return false
    }
  })
}

</script>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

::v-deep .el-form-item {
  margin-bottom: 0;
}

::v-deep .el-button--text {
  margin-right: 15px;
}

::v-deep .el-select {
  width: 250px;
}

::v-deep .el-input,
.el-date-editor.el-input {
  width: 250px;
}

::v-deep .dialog-footer button:first-child {
  margin-right: 10px;
}

.table-details p {
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 24px;
  padding-left: 45px;
}

.table-details span {
  font-size: 12px;
  display: inline-block;
  width: 100px;
  font-weight: bold;
}
</style>